// src/pages/Dashboard.jsx
// Simple redirect to transactions — extend this later with a full dashboard
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Dashboard() {
  const navigate = useNavigate()
  useEffect(() => { navigate('/transactions', { replace: true }) }, [navigate])
  return null
}
